import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Redirect } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { isArray } from "highcharts";
import $ from "jquery";
import CryptoJS from "crypto-js";
import ControlledAccess from "./controlledaccess";
var redirectURL = require("../redirectURL");
var googleAnalytics = require("../common/googleanalytics");

export default class AuthCallBack extends Component {
  constructor(props) {
    super(props);
    var pageTitle = "Login";
    this.state = {
      //pageTitle: pageTitle,
      eventGridAction: "gridAction",
      eventCounterAction: "counterAction",
      eventFormAction: "formAction",
      style: {},
      email: "",
      password: "",
      loginMessage: "",
      currentDepartmentCode: null,
      firstname: "",
      lastname: "",
      email: "",
      is_load_management: 1,
      tokenGenerated: false,
      loadshow: "show-m",
      overly: "show-m",
    };
  }
  logPageView = () => {
    try {
      if (googleAnalytics.page.enableGA) {
        googleAnalytics.logPageView();
        let eventGridAction =
          googleAnalytics.page.actionType.gridAction +
          " - " +
          window.location.pathname;
        let eventCounterAction =
          googleAnalytics.page.actionType.counterAction +
          " - " +
          window.location.pathname;
        let eventFormAction =
          googleAnalytics.page.actionType.formAction +
          " - " +
          window.location.pathname;
        this.setState({
          eventGridAction: eventGridAction,
          eventCounterAction: eventCounterAction,
          eventFormAction: eventFormAction,
        });
      } else {
        console.log("GA disabled...");
      }
    } catch (error) {
      console.error("Error occured while logging to GA, error = ", error);
    }
  };

  cipher = (salt) => {
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return (text) =>
      text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
  };
  loginWithAdfs = (email) => {
    this.setState({
      loadshow: "show-m",
      overly: "show-m",
    });
    if (googleAnalytics.page.enableGA) {
      let pageTitle = this.state.pageTitle;
      let eventOptions = {
        category: pageTitle,
        action: this.state.eventFormAction,
        label: googleAnalytics.page.action.formSubmittedLogin,
      };
      googleAnalytics.logEvent(eventOptions);
    }

    let params = {
      email:email
    };
    redirectURL
      .post("/lmconsignees/getMSILUsersData",params)
      .then(async (response) => {
        // console.log("After login authcallback", response);
        // console.log("In  authcallback response.data = ", response.status == 200 && response.data.msg,response.status == 200);
        if (response.status == 200 && response.data.msg == "Success") {
          console.log("In  authcallback response.data = ", response.status == 200);
          console.log("In  authcallback response.data = ", response.data.length);
          if (response.data.auth == true) {
            if (
              response.data.otpAuthentication == 1 &&
              response.data.otp != ""
            ) {
              console.log("In  if otpAuthentication = ", response.data.otpAuthentication);
              this.setState({
                otpAuthentication: response.data.otpAuthentication,
                otp: response.data.otp,
                otpMessage: "OTP has been sent to your Email",
                userData: response.data,
                successLogin: 0,
                loadshow: "show-n",
                overly: "show-n",
              });
              $("#entered_otp").val("");
            } else {
              console.log("In else otpAuthentication = ", response.data.otpAuthentication);
              this.setState({
                successLogin: 1,
              });
              console.log(response.data.user, "response.data.user");
              var userloggparams = {
                token: response.data.token,
                userId: response.data.userid,
              };
              await redirectURL
                .post("/manage/saveuserlogged", userloggparams)
                .then((resp) => {
                  console.log("resp ", resp);
                });

              //	console.log("In  LoginForm response.data.user.dept_code = ", response.data.user.dept_code);
              var encrypted_token = window.btoa(response.data.token);
              // console.log("encrypted_token ", encrypted_token);
              localStorage.setItem("_t", encrypted_token);     
              console.log("In  LoginForm, response.data.userid = ", response.data.userid);         
              localStorage.setItem("userid", response.data.userid);
              console.log("In  LoginForm, response.data.user = ", response.data.user.dept_code);
              let deptCode = JSON.stringify(response.data.user.dept_code);
              //console.log("In  LoginForm, response.data = ", response.data);
              localStorage.setItem("dept_code", deptCode);
              localStorage.setItem("is_admin", response.data.user.is_admin);
              localStorage.setItem(
                "is_dept_admin",
                response.data.user.is_dept_admin
              );
              localStorage.setItem("is_global", response.data.user.is_global);
              localStorage.setItem("firstname", response.data.user.firstname);
              localStorage.setItem("username", response.data.user.username);
              localStorage.setItem("lastname", response.data.user.lastname);
              localStorage.setItem("email", response.data.user.email);
              localStorage.setItem("user_type", response.data.user.user_type);
              //console.log("response.data.menus ", response.data.menus);
              localStorage.setItem(
                "usermenus",
                JSON.stringify(response.data.menus)
              );
              //console.log("response.data.usermenucodes ", response.data.usermenucodes);
              localStorage.setItem(
                "usermenucodes",
                JSON.stringify(response.data.usermenucodes)
              );
              localStorage.setItem(
                "transportercode",
                JSON.stringify(response.data.user.transporter_code)
              );
              localStorage.setItem(
                "is_sales_type",
                response.data.user.is_sales_type
              );
              localStorage.setItem("sales_type", response.data.user.sales_type);
              localStorage.setItem("region", response.data.user.region);
console.log("response.data.user.roles ", response.data.user.roles);
              localStorage.setItem("roles", response.data.user.roles);
              localStorage.setItem(
                "is_enmovil_transporter",
                this.state.is_enmovil_transporter
              );
              localStorage.setItem(
                "is_load_management",
                this.state.is_load_management
              );
              localStorage.setItem(
                "is_sub_user",
                response.data.user.is_sub_user
              );
              localStorage.setItem("cha_code", response.data.user.cha_code);
              var md = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
              var m = md(JSON.stringify(response.data.user));
              localStorage.setItem("m", m);

              //localStorage.setItem('m', JSON.stringify(response.data.user));
              localStorage.setItem(
                "supplier_code",
                response.data.user.supplier_code
              );
              try {
                if (response.data.user.ro_zone != undefined) {
                  localStorage.setItem("ro_zone", response.data.user.ro_zone);
                } else if (response.data.user.vehicle_group != undefined) {
                  localStorage.setItem(
                    "vehicle_group",
                    response.data.user.vehicle_group
                  );
                } else {
                  localStorage.setItem("vehicle_group", "");
                }
              } catch (e) {}

              //console.log('users roles', typeof response.data.user.roles);
              sessionStorage.setItem("ref", 1);
              var comp_code = "";
              // if(response.data.user.loading_port_code !=undefined)
              // {
              // 	var params = {
              // 		loading_port_code : response.data.user.loading_port_code
              // 	}
              // 	await redirectURL.post("/lmconsignees/getLmLoadingPortName",params).then((response1)=>{
              // 		//console.log(response1.data,"LLPN");
              // 		var lpData = response1.data;
              // 		var lpNames = [];
              // 		if(lpData.length > 0)
              // 		{
              // 			lpData.map((item) => {
              // 				if(item.comp_short_name != '' && item.comp_short_name != undefined)
              // 				{
              // 					lpNames.push({
              // 						loading_port_code:item.loading_port_code,
              // 						loading_port:item.comp_short_name,
              // 					})
              // 					if(response.data.user.loading_port_code[0] == item.loading_port_code)
              // 					{
              // 						comp_code = item.comp_code;
              // 						localStorage.setItem('comp_code', item.comp_code);
              // 					}
              // 				}
              // 			})

              // 		}
              // 		//console.log(lpNames,"lpNames")
              // 	localStorage.setItem('loadingPointName', JSON.stringify(lpNames));
              // 		//console.log(localStorage.getItem("loadingPointName"),"Point Name")
              // 	}).catch((e)=>{
              // 		console.log(e);
              // 	})
              // 	localStorage.setItem('loading_port_code', response.data.user.loading_port_code[0]);
              // }
              if (response.data.user.is_load_management == 1) {
                if (response.data.user.roles == "lm_site_admin") {
                  await redirectURL
                    .post("/lmconsignees/getLmLoadingPorts")
                    .then((response2) => {
                      //console.log(response1.data,"LLPN");
                      var lpData = response2.data;
                      var lpNames = [];
                      if (lpData.length > 0) {
                        lpData.map((item) => {
                          if (
                            item.comp_short_name != "" &&
                            item.comp_short_name != undefined
                          ) {
                            lpNames.push({
                              loading_port_code: item.loading_port_code,
                              loading_port: item.comp_short_name,
                            });
                          }
                        });
                        comp_code = lpData[0].comp_code;
                        localStorage.setItem("comp_code", lpData[0].comp_code);
                        localStorage.setItem(
                          "loading_port_code",
                          lpData[0].loading_port_code
                        );
                      }
                      //console.log(lpNames,"lpNames")
                      localStorage.setItem(
                        "loadingPointName",
                        JSON.stringify(lpNames)
                      );
                      //console.log(localStorage.getItem("loadingPointName"),"Point Name")
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                }
              }
              if (response.data.user.is_load_management != undefined) {
                localStorage.setItem(
                  "is_load_management",
                  response.data.user.is_load_management
                );
                if (comp_code != "" && comp_code != undefined) {
                  var userloggparams = {
                    token: response.data.token,
                    userId: response.data.userid,
                    comp_code: comp_code,
                  };
                  await redirectURL
                    .post("/manage/updateUserCompCode", userloggparams)
                    .then((resp) => {
                      console.log("resp ", resp);
                    });
                }
              }
              if (response.data.user.lm_department != undefined) {
                localStorage.setItem(
                  "lm_department",
                  response.data.user.lm_department
                );
              }
              if (response.data.user.designation != undefined) {
                localStorage.setItem(
                  "designation",
                  response.data.user.designation
                );
              }
              if (response.data.user.active_status != undefined) {
                localStorage.setItem(
                  "active_status",
                  response.data.user.active_status
                );
              }
              if (response.data.user.is_department_admin != undefined) {
                localStorage.setItem(
                  "is_department_admin",
                  response.data.user.is_department_admin
                );
              }
              if (response.data.user.staff_id != undefined) {
                localStorage.setItem("staff_id", response.data.user.staff_id);
              }
              if (response.data.user.dept_head_id != undefined) {
                localStorage.setItem(
                  "dept_head_id",
                  response.data.user.dept_head_id
                );
              }
              if (response.data.user.report_manager_id != undefined) {
                localStorage.setItem(
                  "report_manager_id",
                  response.data.user.report_manager_id
                );
              }
              this.setState({
                currentDepartmentCode: response.data.user.dept_code,
              });
              if (response.data.token) {
                axios.defaults.headers.common[
                  "Authorization"
                ] = `Bearer ${response.data.token}`;
              } else {
                delete axios.defaults.headers.common["Authorization"];
              }

              this.setState({
                username: "",
                email: "",
                password: "",
                loginMessage: response.data.msg,
                loadshow: "show-n",
                overly: "show-n",
              });
            }
console.log("In  LoginForm, after else ", response.data.msg);
            redirectURL
                      .post(
                        "/menus/getmenus",
                        {},
                        {
                          headers: {
                            "Content-Type": "application/json",
                          },
                        }
                      )
                      .then((response) => {
                        //console.log("Menus ",response);
                        if (response.statusText == "OK") {
                          //console.log("In  SIDEBAR LoginForm MENUS response.data = ", response.data);
                          let menuText = JSON.stringify(response.data);
                          localStorage.setItem("menuText", menuText);
                        } else {
                          this.setState({
                            username: "",
                            email: "",
                            password: "",
                            loginMessage: response.data.msg,
                          });
                        }
                        let MENUITEMS = getMenuLocalStorage();

                        //console.log("IN Sidebar componentWillMount, From DB MENUITEMS menuList ", MENUITEMS);
                      })
                      .catch(function(error) {
                        console.log("callback menus",error);
                      });
          } else {
            this.setState({
              username: "",
              email: "",
              password: "",
              loginMessage: response.data.msg,
              loadshow: "show-n",
                overly: "show-n",
            });
          }
        } else {
          console.log("In  LoginForm, outer else response.data.msg = ", response.data.msg);
        await  this.setState({
            username: "",
            email: "",
            password: "",
            loginMessage: response.data.msg,
            loadshow: "show-n",
                overly: "show-n",
          });
        }
        //console.log(window.atob(localStorage.getItem('_t')));
      })
      .catch((error) => {
        console.log("callback userdata",error,error.response);
        let loginMessage = "";
          if (error.response && error.response.status === 504) {
            loginMessage = "API timeout, please try again";
          }
          this.setState({
            loadshow: "show-n",
            overly: "show-n",
            loginMessage: loginMessage,
          });
      });

    // another call to find menus for the user
    
  };

  async componentDidMount() {
    // setTimeout(()=>{
    var ctr = 0;
    while (ctr == 0) {
      const storagekeys = Object.keys(localStorage);
      var key = storagekeys.filter((e) => e.includes("idToken"));
      // console.log(localStorage.getItem(key), "key ");
      let token = localStorage.getItem(key);
      if (token != undefined && token != "") {
        localStorage.setItem("token", token);
        ctr = ctr + 1;
        break;
      }
      await sleep(1000);
    }

    let token = localStorage.getItem("token");
    var decoded_token = jwtDecode(token);
    var email = decoded_token.payload.email;
    var msil_user = email.split("@")[0];
    var msil_user_firstname = msil_user.split(".")[0];
    var msil_user_lastname = msil_user.split(".")[1];
    localStorage.setItem("msiluserfirstname", msil_user_firstname);
    localStorage.setItem("msiluserlastname", msil_user_lastname);
    console.log(
      "decoded_token",
      decoded_token.payload.email,
      decoded_token,
      decoded_token.payload.identities[0].userId,
      decoded_token.payload.identities[0].userId.split("\\")[1]
    );
    var user_id = decoded_token.payload.identities[0].userId.split("\\")[1];
    this.loginWithAdfs(email);
    // await redirectURL
    //   .post("/adfslogin", { email: email, userId: user_id, token: token })
    //   .then(async (response) => {
    //     console.log(response, "login response");

    //     if (
    //       response.data.msil_user == false &&
    //       [
    //         "enmovil_syamkumar.siddula@maruti.co.in",
    //         "sc_bdy@maruti.co.in",
    //       ].includes(email.toLowerCase())
    //     ) {
    //       this.props.history.push("/logout");
    //     } else {
    //       var userloggparams = {
    //         token: token,
    //         userId: decoded_token.payload.identities[0].userId,
    //         email: decoded_token.payload.email,
    //         user_type: decoded_token.payload.identities[0].providerType,
    //         msil_dept_code: response.data.msil_dept_code,
    //       };

    //       await redirectURL
    //         .post("/manage/saveuserlogged", userloggparams)
    //         .then((resp) => {
    //           console.log("sessionId", resp.data.sessionId);
    //           localStorage.setItem("sessionId", resp.data.sessionId);
    //         });

    //       console.log("response.data", response.data);
    //       localStorage.setItem("userid", response.data.userid);
    //       localStorage.setItem("is_admin", true);

    //       localStorage.setItem("firstname", msil_user_firstname);
    //       localStorage.setItem("username", msil_user_firstname);
    //       localStorage.setItem("lastname", msil_user_lastname);

    //       localStorage.setItem("email", decoded_token.payload.email);
    //       localStorage.setItem(
    //         "usermenus",
    //         JSON.stringify(response.data.menus)
    //       );
    //       localStorage.setItem(
    //         "usermenucodes",
    //         JSON.stringify(response.data.usermenucodes)
    //       );
    //       localStorage.setItem(
    //         "paths",
    //         JSON.stringify(response.data.paths_list)
    //       );

    //       localStorage.setItem("roles", response.data.roles);
    //       // var md = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
    //       // var m = md(JSON.stringify(response.data.user))
    //       sessionStorage.setItem("ref", 1);
    //       // if(response.data.msil_user_role.length>0){
    //       // 	localStorage.setItem("msil_user_role",response.data.roles)
    //       // 	// localStorage.setItem("is_admin",response.data.msil_user_role[0].is_admin)
    //       // 	// localStorage.setItem("employee_id",response.data.msil_user_role[0].employee_id)
    //       // }
    //       // else if(["enmovil_syamkumar.siddula@maruti.co.in"].includes(email.toLowerCase())){
    //       // 	localStorage.setItem("msil_user_role", "")
    //       // 	localStorage.setItem("is_admin", true)
    //       // 	localStorage.setItem("employee_id", email)
    //       // }
    //       // else if(["sc_bdy@maruti.co.in"].includes(email.toLowerCase())){
    //       // 	localStorage.setItem("msil_user_role", "")
    //       // 	localStorage.setItem("is_admin", false)
    //       // 	localStorage.setItem("employee_id", email)
    //       // }
    //     }
    //   });

    this.setState({
      tokenGenerated: true,
      loadshow: "show-m",
      overly: "show-m",
    });
    // this.logPageView(); // Log page view to GA
  }

  getUserDashboardUrl(pathToMatch = null) {


  	let dashboardUrl = "/lmwelcome";
  	let currentDepartmentCode = null;
  	let departmentCode = JSON.parse(localStorage.getItem("dept_code"));

  	//console.log("IN render, departmentCode ", departmentCode);
  	if (Array.isArray(departmentCode)) {
  		currentDepartmentCode = departmentCode[0];
  	} else {
  		currentDepartmentCode = departmentCode;
  	}

  	console.log("dashboardUrl Login", dashboardUrl)
  	return dashboardUrl;
  }

  // componentWillReceiveProps() {
  //   var pageTitle = "Login";
  //   this.setState({
  //     pageTitle: pageTitle,
  //   });
  // }

  componentDidUpdate(prevProps) {
    // console.log("In componentDidUpdate, this.props = ", this.props);
    // console.log("In componentDidUpdate, prevProps = ", prevProps);
    if (this.props !== prevProps) {
      var pageTitle = "ADFS Login";
      this.setState({
        pageTitle: pageTitle,
      });
    }
  }

  changeHandler = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };
  formHandler = (event) => {
    console.log(this.state.login_id);
    console.log(this.state.password);
  };

  // render() {
  //   console.log(localStorage.getItem("token"), "token140");
  // if (
  //     localStorage.getItem("token") != "" &&
  //     localStorage.getItem("token") != null
  //   ) {
  //     let dashboardUrl = "/lmwelcome";
  //     return <Redirect to={dashboardUrl} push={true} />;
  //   }
  //   return (
  //     <>
  //       <div className={"dataLoadpage " + this.state.loadshow}></div>
  //       <div className={"dataLoadpageimg " + this.state.loadshow}>
  //         <div class="loader-box">
  //           <div class="loader-box">
  //             <div class="rotate dashed colored"></div>
  //           </div>
  //         </div>
  //       </div>

  //       <div className={"overlay-part " + this.state.overly}></div>
  //     </>
  //   );
  // }

  render(){
    console.log("In render",localStorage.getItem("_t"));

    if(this.state.loadshow == "show-m" && this.state.overly == "show-m"){

      return (
        <>
          <div className={"dataLoadpage " + this.state.loadshow}></div>
          <div className={"dataLoadpageimg " + this.state.loadshow}>
            <div class="loader-box">
              <div class="loader-box">
                <div class="rotate dashed colored"></div>
              </div>
            </div>
          </div>
  
          <div className={"overlay-part " + this.state.overly}></div>
        </>
      );
    }

		if(localStorage.getItem('_t') != '' && localStorage.getItem('_t') != null && localStorage.getItem('_t') != "null")
		{
			let dashboardUrl = this.getUserDashboardUrl();
      console.log("dashboardUrl callback", dashboardUrl)
			return <Redirect to={dashboardUrl} push={true} />
		}else if(this.state.loginMessage == "No User Found..."){
      console.log("In render, this.state.loginMessage = ", this.state.loginMessage);
      return (
        <ControlledAccess/>
      );
    }else{
      let dashboardUrl = this.getUserDashboardUrl();
      console.log("else dashboardUrl callback", dashboardUrl)
      console.log("In render else, this.state.loginMessage = ", this.state.loginMessage);
      return (
        <div>API timeout, please try again...</div>
      );

    }
	}
};


function getMenuLocalStorage() {
  let menuText = localStorage.getItem("menuText");
  let MENUITEMS = null;
  //   console.log("deptCodes = ", deptCodes);
  //   console.log("Type of deptCodes = ", typeof deptCodes);
  try {
    MENUITEMS = JSON.parse(menuText);
  } catch (error) {
    console.log("Error while Parsing menuText", error);
  }
  return MENUITEMS;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function jwtDecode(t) {
  let token = {};
  token.raw = t;
  token.header = JSON.parse(window.atob(t.split(".")[0]));
  token.payload = JSON.parse(window.atob(t.split(".")[1]));
  return token;
}
